import { render, staticRenderFns } from "./PromotionOrganizationsTable.vue?vue&type=template&id=6cd7f2a9"
import script from "./PromotionOrganizationsTable.vue?vue&type=script&lang=js"
export * from "./PromotionOrganizationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports